import { dateFns, instantFns, Iso, yearMonthFns } from 'iso-fns2'

interface BillingPeriodBrand extends String {}

export type BillingPeriod = Iso.YearMonth & BillingPeriodBrand

function CurrentPeriod() {
  return dateFns.toYearMonth(dateFns.now())
}

function fromIsoDate(date: Iso.Date) {
  return dateFns.toYearMonth(date)
}

function getMoments(billingPeriod: Iso.YearMonth) {
  const startInstant = yearMonthFns
    .chain(billingPeriod)
    .toDate(1)
    .toZonedDateTime({ timeZone: 'America/Chicago' })
    .toInstant()
    .value()
  const endInstant = yearMonthFns
    .chain(billingPeriod)
    .add({ months: 1 })
    .toDate(1)
    .toZonedDateTime({ timeZone: 'America/Chicago' })
    .toInstant()
    .subtract({ milliseconds: 1 })
    .value()
  return { startInstant, endInstant }
}

function toDateRange(billingPeriod: BillingPeriod): { startDate: Iso.Date; endDate: Iso.Date } {
  const { startInstant, endInstant } = getMoments(billingPeriod)

  const start = instantFns.chain(startInstant).toZonedDateTime('America/Chicago').format('yyyy-MM-dd').value()
  const end = instantFns.chain(endInstant).toZonedDateTime('America/Chicago').format('yyyy-MM-dd').value()
  return { startDate: dateFns.from(start), endDate: dateFns.from(end) }
}

function getPreviousBillingPeriod(billingPeriod: BillingPeriod): BillingPeriod {
  return yearMonthFns.subtract(billingPeriod, { months: 1 })
}

function getNextBillingPeriod(billingPeriod: BillingPeriod): BillingPeriod {
  return yearMonthFns.add(billingPeriod, { months: 1 })
}

function atDay(billingPeriod: BillingPeriod, day: number): Iso.Date {
  return yearMonthFns.toDate(billingPeriod, day)
}

export const BillingPeriodFns = {
  CurrentPeriod,
  fromIsoDate,
  toDateRange,
  getPreviousBillingPeriod,
  getNextBillingPeriod,
  atDay,
  getMoments
}
